import _ from 'lodash';
import { useBeforeunload } from 'react-beforeunload';

export const useAsyncCallBeforeClose = (shouldCall = _.constant(true)) => {
  const preClose = event => event.preventDefault();
  return useBeforeunload(shouldCall() ? preClose : _.noop);
};
